<template>
    <div>
        <div class="left-toolbar mb10">
            <button @click="exportPdf" class="swb-btn-small swb-btn">导出为pdf</button>
        </div>
        <swb-servc-work-add-item-list :id="id" ref="swb_servc_work_add_item_list"></swb-servc-work-add-item-list>
    </div>
</template>
<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import { showHtmlToPdfDlg } from '../ctrl/dialog'

    import SwbServcWorkAddItem from './ServcWorkAddItem';
    Vue.regist(SwbServcWorkAddItem);

    export default {
        name: 'swb-servc-work-add-item-list-export',
        desc: '工单补充项目导出',
        props: {
            id: {
                type: Number,
                deafult: null,
            },
            title: {
                type: String,
                deafult: null,
            }
        },
        data: function () {
            return {}

        },
        created: function () {

        },
        methods: {
            exportPdf: function () {
                let self = this;
                let result = self.$refs.swb_servc_work_add_item_list.getHtml() || '';
                showHtmlToPdfDlg(self.title, result, null);
            }
        }
    }
</script>





// WEBPACK FOOTER //
// src/compo/workVoucher/ServcWorkAddItemExportPdf.vue